//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TemplateCard",
  components: {
    InlinePrompt
  },
  props: {
    templateId: {
      type: [String, Number],
      default: ""
    },
    thumbnail: {
      type: String,
      default: ""
    },
    templateName: {
      type: String,
      default: ""
    },
    category: {
      type: String,
      default: ""
    },
    deleteTemplate: {
      type: Boolean,
      default: false
    },
    editTemplate: {
      type: Boolean,
      default: false
    },
    selectPage: {
      type: Boolean,
      default: true
    },
    actions: {
      type: Boolean,
      default: false
    },
    deleted: {
      type: Boolean,
      default: false
    },
    showDisabledActions: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nameIsEmpty() {
      return this.templateName === "Empty";
    },
    templateStyle() {
      return !this.nameIsEmpty && {
        "background-image": `url(${this.thumbnail})`
      };
    },
    showDeleteButton() {
      return this.deleteTemplate && !this.selectPage && !!this.templateId;
    },
    isEditDisabled() {
      return !this.editTemplate || this.deleted || this.showDisabledActions;
    }
  },
  methods: {
    handleEdit() {
      this.$emit("edit");
    },
    handlePreview() {
      this.$emit("preview");
    },
    handleDuplicate() {
      this.$emit("duplicate");
    },
    handleSelect() {
      this.$emit("select");
    },
    handleDelete() {
      this.$emit("delete");
    }
  }
});